import {
  // appPARAMETER types
  FETCH_PROJECTNAMERESIS_GGN,
  FETCH_PROJECTNAMECOMS_GGN,
  FETCH_LOCALITYS_GGN,
} from "../actions/types";

const INITIAL_STATE = {
  projectNameResis: [],
  projectNameComs: [],
  localitys: [],
  offset: 0,
  limit: 10,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PROJECTNAMERESIS_GGN:
      return { ...state, ...action.payload };
    case FETCH_PROJECTNAMECOMS_GGN:
      return { ...state, ...action.payload };
    case FETCH_LOCALITYS_GGN:
      return { ...state, ...action.payload };

    
    default:
      return state;
  }
};
